import { render, staticRenderFns } from "./Resultados.vue?vue&type=template&id=4871c5e6&scoped=true&lang=pug"
import script from "./Resultados.vue?vue&type=script&lang=js"
export * from "./Resultados.vue?vue&type=script&lang=js"
import style0 from "./Resultados.styl?vue&type=style&index=0&id=4871c5e6&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4871c5e6",
  null
  
)

export default component.exports